module.exports = __webpack_public_path__ + "static/media/3DPPA32.eb203a5f.jpg";